import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import COLORS from '@dabea/common/lib/constants/colors'
import * as sharedStyles from '@dabea/common/lib/styles/styled'

import Logo from '@dabea/common/lib/components/Logo'

import EjendomDanmarkSvg from '@dabea/common/lib/images/ejendomdanmark.svg'

const Container = styled.div`
  ${sharedStyles.textFont}
  display: flex;
  flex-direction: column;
  border-top: 1px solid;
  border-color: ${COLORS.BRAND_COLOR_LIGHTBLUE};
  padding-top: 30px;
  align-items: center;
  min-height: 200px;
  font-size: 14px;
  padding-bottom: 10px;
`

const Item = styled.div`
  margin: 10px;

  span {
    display: block;
  }
`

const EjendomDamarkImg = styled.img`
  margin-left: 20px;
  width: 150px;
`

const Footer = () => (
  <Container>
    <Item>
      <Logo height={30} />
    </Item>
    <Item>
      <span style={{ marginTop: '1rem' }}>Pilestræde 40B, 2. sal</span>
      <span>1112 København K</span>
      <span style={{ marginTop: '1rem' }}>
        {'email '}
        <a href="mailto:kontakt@dabea.dk" rel="nofollow">
          kontakt@dabea.dk
        </a>
      </span>
      <span>
        {'tlf '}
        <a href="tel:21866844" rel="nofollow">
          21 86 68 44
        </a>
      </span>
      <span style={{ marginTop: '1rem' }}>cvr 39588099</span>
    </Item>
    <Item>
      <Link to="/ejerforening">Læs mere om ejerforening</Link> <br />
      <Link to="/andelsboligforening">
        Læs mere om andelsboligforening
      </Link>{' '}
      <br />
      <Link to="/grundejerforening">Læs mere om grundejerforening</Link>
    </Item>
    <Item>
      <span>
        {'Læs vores '}
        <a href="/privatlivspolitik.html" target="_blank" rel="nofollow">
          privatlivspolitik
        </a>
      </span>
    </Item>
    <Item>
      Medlem af
      <a href="https://ejd.dk" target="_blank" rel="noopener noreferrer">
        <EjendomDamarkImg src={EjendomDanmarkSvg} alt="Ejendom danmark" />
      </a>
    </Item>
    <Item
      style={{ marginBottom: '2rem', color: `${COLORS.BRAND_COLOR_BODYLIGHT}` }}
    >
      © 2018 DABEA All rights reserved
    </Item>
  </Container>
)

export default Footer
